import React from 'react';
import { generateUrl } from '../../utils';
import { thumbnailSrc } from '../../utils/news';
import { Link, Tag } from '../base-ui';
import StickyAd from './StickyAd';
import StickyAdBottom from './StickyAdBottom';

export default function AdSelection({
    ads = [],
    location,
    className,
    Wrapper = false,
    wrapperClassName,
    wrapperStyle,
    style,
    showIfEmpty = false,
    AdRender,
}) {
    const adItems = ads.filter(a => a.location === location)
        .sort((a, b) => Number(a.position ?? 0) - Number(b.position ?? 0))
        .map(a => {
            let adProps = []

            switch (a.content_type) {
                case 'NEWS_BY_SERVICE':
                case 'NEWS_BY_ID':
                    {
                        if (!a.news) return null
                        if (!Array.isArray(a.news))
                            a.news = [a.news]
                        adProps = a.news.filter(Boolean).map((news) => ({
                            src: thumbnailSrc(news.thumbnail),
                            href: generateUrl(news, 'news'),
                            title: news.title,
                            nofollow: a.nofollow,
                            id: news.id,
                        }))
                    }
                    break;
                case 'MEDIA':
                    {
                        adProps = [{
                            href: a.url,
                            title: a.content,
                            nofollow: a.nofollow,
                            displayStyle: a.displayStyle,
                            src: thumbnailSrc({ file: a.file }),
                        }]
                    }
                    break;
                case 'LINK':
                    {
                        adProps = [{
                            href: a.url,
                            title: a.content ?? a.title,
                            nofollow: a.nofollow,
                        }]
                    }
                    break;
                case 'PROVIDER':
                case 'IFRAME':
                    {
                        adProps = [{
                            content: a.content,
                        }]
                    }
                    break;
            }
            if (AdRender) return adProps.map((adProp) => <AdRender key={adProp.id} {...adProp} />)
            // if (React.isValidElement(adRender))
            //     return adProps.map((adProp) => React.cloneElement(adRender, null, adProp))

            if (a.location === 'news_sticky_side' && !['PROVIDER', 'IFRAME'].includes(a.content_type)) {
                const style = {}
                if (a.location.includes('sticky_side') && a.cssStyle?.right) style.right = a.cssStyle?.right
                if (a.location.includes('sticky_side') && a.cssStyle?.bottom) style.bottom = a.cssStyle?.bottom

                return adProps.map((adProp) => <StickyAd
                    key={a.id}
                    imageSrc={adProp.src}
                    href={adProp.href}
                    title={adProp.title}
                    orientation="horizontal"
                    style={style}
                />)
            }
            if ((a.location.includes('sticky_bottom') || a.location.includes('sticky_top'))
                && !['PROVIDER', 'IFRAME'].includes(a.content_type)) {
                const style = {}
                if (a.location.includes('sticky_top') && a.cssStyle?.top) style.top = a.cssStyle?.top
                if (a.location.includes('sticky_bottom') && a.cssStyle?.bottom) style.bottom = a.cssStyle?.bottom

                return adProps.map((adProp) => <StickyAdBottom
                    key={a.id}
                    position={a.location.includes('sticky_top') ? 'top' : 'bottom'}
                    href={adProp.href}
                    title={adProp.title}
                    imgSrc={adProp.src}
                    displayStyle={a.displayStyle ?? 'media_text'}
                    style={style}
                />)
            }
            return adProps.map((adProp) => <div key={a.id} className={className} data-adtitle={a.title}>
                {(a.content_type === 'PROVIDER' || a.content_type === 'IFRAME') && <ProviderAd {...adProp} style={style} />}
                {a.content_type === 'LINK' && <LinkAd {...adProp} style={style} />}
                {a.content_type === 'MEDIA' && <MediaAd {...adProp} style={style} />}
            </div>)
        })

    if (adItems.length === 0 && !showIfEmpty) return null

    if (Wrapper) return <Wrapper>{adItems}</Wrapper>
    if (Wrapper === false) return adItems
    return <div style={wrapperStyle} className={wrapperClassName}>
        {adItems}
    </div>
}

export function ProviderAd({ content = '' }) {
    return <div className="providerads" dangerouslySetInnerHTML={{ __html: content }}></div>
}

export function LinkAd({ nofollow = true, href = '', title = '', ad }) {
    return <Tag href={href ?? ad.href} nofollow={nofollow ?? ad.nofollow} target="_blank">
        {title ?? ad.href}
    </Tag>
}

export function MediaAd({ href = '', nofollow = true, src = '', displayStyle = 'image_only', title = '', style }) {
    return <Link href={href} rel={nofollow ? 'nofollow' : 'follow'}>
        <div>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={src} alt={title ?? 'تبلیغ'} loading="lazy" style={style} />
            {displayStyle === 'image_text' && <div>{title}</div>}
        </div>
    </Link>
}